<template>
  <div>
    <table border="1px solid black" class="shablo_table">
      <thead style="text-align: center;">
        <tr>
          <th style="width: 2%; height: 130px;">№</th>
          <th style="width: 250px;">Dori darmonlar</th>
          <th style="width: 250px;">Izoh</th>
          <th v-for="item in days" style="width: 80px !important;">
            <div class="card_month">
              {{ item }}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr style="height: 30px;" v-for="(item, index) in trDatas" :key="index">
          <td>{{ index + 1 }}</td>
          <td>
            {{ item.name }}
          </td>
          <td>
            {{ item.comment }}
          </td>
          <td style="padding: 0px !important;" v-for="itemTd in days">
            <div
              v-if="
                registration_drug.map(
                  rd =>
                    rd.reagent.id == item.id && rd.date == itemTd && !rd.deleted
                )
              "
            >
              <div
                v-for="(rd, idx) in registration_drug"
                v-if="
                  rd.reagent.id == item.id && rd.date == itemTd && !rd.deleted
                "
                :key="idx"
              >
                <input
                  v-for="itemch in rd.time_change"
                  v-model="itemch.change"
                  type="checkbox"
                />
              </div>
            </div>
            <div v-else>
              <div style="height: 30px;"></div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      data: {},
      registration_drug: [],
      trDatas: [],
      days: []
    };
  },
  filters: {
    dateFormat: function(date) {
      if (date) {
        return moment.unix(date).format("DD.MM.YYYY");
      } else {
        return "";
      }
    }
  },
  created: function() {
    this.registration_drug = JSON.parse(
      localStorage.getItem("muolaja")
    ).data.drug;
    this.trDatas = JSON.parse(localStorage.getItem("muolaja")).data.trDatas;
    this.days = JSON.parse(localStorage.getItem("muolaja")).data.days;
  },
  mounted() {
    // localStorage.removeItem("muolaja");
    // window.print();
    // setTimeout(() => {
    // //   this.$router.push({ path: "/user" });
    //   window.close();
    // }, 3000);
  }
};
</script>
<style>
.card_month {
  transform: rotate(270deg);
  font-size: 11pt;
}
input[type="checkbox"] {
  transform: scale(1.5);
  margin: 5px;
}
</style>
